import React, {useEffect, useState} from 'react'

import {
    MutateContainer,
    Heading,
    FormContainer,
    MutateForm,
    Label,
    MutateSelect,
    MutateSubmit,
    TextField,
    TextFieldError,
    BrainzInput,
    SuccessChance
} from './MutateElements'
import {brainzBalance, mutate} from "../../../Contract/Web3Client";
import {SelectOption} from "./RerollElements";
import {RerollTrait} from "../../../utils/Enums";

const Mutate = ({tokens, address}) => {
    const [donorId, setDonorId] = useState(0)
    const [recipientId, setRecipientId] = useState(0)
    const [count, setCount] = useState(1)
    const [trait, setTrait] = useState(0)
    const [brainz, setBrainz] = useState(0)
    const [error, setError] = useState("")

    const chance = () => {
        return (100 * count / (count + 3)).toFixed(0);
    }

    useEffect(() => {
        if (count > brainz) {
            setError("Can't Use More Brainz Than You Own");
        }
        else if (error === "Can't Use More Brainz Than You Own") {
            setError("");
        }
    }, [])

    useEffect(async () => {
        setBrainz(await brainzBalance(address))
    }, [address])

    useEffect(async () => {
        setError("")
        setDonorId(tokens.length === 0 ? 0 : tokens[0].tokenId);
        setRecipientId(tokens.length === 0 ? 0 : tokens[0].tokenId);
    }, [tokens])

    useEffect(() => {
        if (donorId === recipientId) {
            setError("Donor Cannot Be The Recipient");
        }
        else if (error === "Donor Cannot Be The Recipient") {
            setError("")
        }
    }, [donorId, recipientId])

    const submitForm = () => {
        console.log("donor is: " + donorId)
        console.log(tokens.find(x => x.tokenId === donorId))
        console.log("recipient is: " + donorId)
        console.log(tokens.find(x => x.tokenId === recipientId))
        console.log("Trait is: " + trait)
        console.log("count is: " + count)
        mutate(donorId, recipientId, trait, count, address)
    }

    let populateIdDropdown = tokens.map(d => (
        <SelectOption key={d.tokenId} value={d.tokenId}>{d.name}</SelectOption>
    ))

    let populateTraitDropdown = RerollTrait.enumerate.map((name, i) => (
        <SelectOption key={i} value={i}>{name}</SelectOption>
    ))


    return (
        <>
            <MutateContainer>
                <Heading>Mutate Bit Monsters</Heading>
                <TextField>$BRAINZ: {brainz}</TextField>
                <FormContainer>
                  <BrainzInput placeholder="$BRAINZ/($BRAINZ+3)" onChange={e => setCount(parseInt(e.target.value, 10))}/>
                  <SuccessChance>{chance()}% Success Rate</SuccessChance>
                    <MutateForm
                        onSubmit={e => {
                            e.preventDefault()
                            submitForm()
                        }}>
                        <Label>
                            Select Donor Bit Monster:
                            <MutateSelect
                                value={donorId}
                                onChange={e => setDonorId(parseInt(e.target.value, 10))}>
                                {populateIdDropdown}
                            </MutateSelect>
                        </Label>
                        <Label>
                            Select Recipient Bit Monster:
                            <MutateSelect
                                value={recipientId}
                                onChange={e => setRecipientId(parseInt(e.target.value, 10))}>
                                {populateIdDropdown}
                            </MutateSelect>
                        </Label>
                        <Label>
                            Select Trait To Mutate:
                            <MutateSelect
                                value={trait}
                                onChange={e => setTrait(parseInt(e.target.value, 10))}>
                                {populateTraitDropdown}
                            </MutateSelect>
                        </Label>
                        <TextFieldError>{error}</TextFieldError>
                        <MutateSubmit disabled={error.length > 0} type="submit" value="Mutate"/>
                    </MutateForm>
                </FormContainer>
            </MutateContainer>
        </>
    )
}

export default Mutate
